<template>

		<div class="password-container">
				<div class="password-table">
					<div class="password-table-title">修改密码</div>
					<div class="password-table-new"><input type="password" v-model="oldPw" placeholder="请输入旧密码"></div>
					<div class="password-table-new"><input type="password" v-model="newPw" placeholder="请设置新密码"></div>
					<div class="password-table-remake"><input type="password" v-model="newPw2" placeholder="请确认新密码"></div>
					<div class="v-table-input-btn"><button @click="btnClick">确定</button></div>
				</div>
		</div>
</template>

<script>
import {ApiUpdatePassword} from '../../../net/accound/index.js'
import {phoneFun, checkMobile, setCookie, getCookie, removeCookie} from '../../../untils/common.js'
export default {
  data: function () {
    return {
      oldPw: '',
      newPw: '',
      newPw2: ''
    }
  },
  methods: {
    btnClick: function () {
      if (!this.checkLogin()) {return}
      const prames = {
        oldPassword: this.oldPw,
        newPassword: this.newPw
      }
      ApiUpdatePassword(prames).then(res=>{
        if (res.code == 200) {
          this.$message.success('修改成功')
        }
        this.oldPw = ''
        this.newPw = ''
        this.newPw2 = ''
        // console.log('修改密码', res)
      })
    },
    checkLogin: function () {
      if (!checkMobile(this.oldPw)) {
        this.$message({
          message: '旧密码格式有误',
          type: 'warning'
        })
        return false
      }

      if (!checkMobile(this.newPw)) {
        this.$message({
          message: '新密码格式有误',
          type: 'warning'
        })
        return false
      }

      if (this.newPw != this.newPw2) {
        this.$message({
          message: '两次输入密码不一致',
          type: 'warning'
        })
        return false
      }

      return true
    }
  }
}
</script>

<style scoped>
  .password-container{
  	width: 850px;
  	float: right;
  	height: 500px;
  	background: #fff;
  	border-radius: 6px;
  }
  .password-table{
  	width: 320px;
  	margin: 0 auto;
  	overflow: hidden;
  }
  .password-table-title{
  	font-size:20px;
  	color: #252525;
  	margin-top: 50px;
  }
  .password-table-new{
  	width: 320px;
  	margin:0 auto;
  	margin-top: 24px;
  }
  .password-table-new input{
  	width: 298px;
  	height: 38px;
  	border: 1px solid #ccc;
  	border-radius: 4px;
  	padding: 5px;
  	outline: none;
  	font-size: 16px;
    padding-left: 10px;
  }
  .password-table-remake{
  	width: 320px;
  	margin:0 auto;
  	margin-top: 24px;
  }
  .password-table-remake input{
  	width: 298px;
  	height: 38px;
  	border: 1px solid #ccc;
  	border-radius: 4px;
  	padding: 5px;
  	outline: none;
  	font-size: 16px;
    padding-left: 10px;
  }
  .v-table-input-btn{
  	width: 320px;
  	margin-top: 24px;
  }
  .v-table-input-btn button{
  	width: 320px;
  	height: 48px;
  	border-radius: 4px;
  	background-color: #0AAC50;
  	border: none;
  	color: #fff;
  	font-size: 16px;
  	outline: none;
  	border: 1px solid transparent;
  }
  .v-table-input-btn button:hover{
  	background-color: #019B3C;
  	cursor:pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/AccSetting/children/password.vue